import React, { PureComponent } from 'react';
import { Country } from '~/Api/Country';
import { RegionAvailability } from '~/MedicinalBrandsAnalytics/Region';
import Availability from '~/MedicinalBrandsAnalytics/VirtualBrand/Availability';

import styles from './styles.less';

import type { AnalyticDataSources } from '~/Api/Analytics/VirtualBrand/mapAnalyticVirtualBrand';

interface Props {
	availability: { [countryCode: string]: AnalyticDataSources };
	regionAvailabilities: RegionAvailability[] | null;
	countries: Country[] | null;
	selectedRegionAvailability: RegionAvailability | null;
	allowIds: Set<string> | null;
	onSelect(availability: RegionAvailability | null): void;
}

export default class RegionSelect extends PureComponent<Props> {
	static defaultProps = {
		allowIds: null,
	};

	renderList(regionAvailabilities: RegionAvailability[], countries: Country[] | null) {
		const { availability, selectedRegionAvailability, allowIds, onSelect } = this.props;

		return (
			<div className={styles.container}>
				<ul className={styles.list}>
					{countries ? this.renderAllOption(countries) : null}

					{regionAvailabilities.map((regionAvailability, i) => {
						const { region, subRegions, countries } = regionAvailability;
						const isDisabled = allowIds && !allowIds.has(region.id);
						const isSelected = selectedRegionAvailability === regionAvailability;

						return (
							<li key={region.id}>
								<div
									className={isDisabled ? styles.disabledItem : isSelected ? styles.selectedItem : styles.item}
									role='button'
									tabIndex={i}
									onClick={isSelected || isDisabled ? undefined : () => onSelect(regionAvailability)}
								>
									<strong className={styles.title}>{region.title} </strong>
									<Availability availability={availability} countries={countries} invertColors={isSelected} />
								</div>

								{this.renderList(subRegions, null)}
							</li>
						);
					})}
				</ul>
			</div>
		);
	}

	renderAllOption(countries: Country[]) {
		const { availability, selectedRegionAvailability, allowIds, onSelect } = this.props;
		const isSelected = selectedRegionAvailability === null;

		return (
			<li>
				<div
					className={allowIds ? styles.disabledItem : isSelected ? styles.selectedItem : styles.item}
					role='button'
					tabIndex={-1}
					onClick={isSelected || allowIds ? undefined : () => onSelect(null)}
				>
					<strong className={styles.title}>All </strong>
					<Availability availability={availability} countries={countries} invertColors={isSelected} />
				</div>
			</li>
		);
	}

	render() {
		const { regionAvailabilities, countries } = this.props;
		return regionAvailabilities && countries ? this.renderList(regionAvailabilities, countries) : null;
	}
}
